// Öffentliche Seiten (Startseite, Betreiber-Seite). Der Inhalt kommt fertig vom Server — hier nur Zahlen nachladen
// und die Knöpfe an den Besucher anpassen. Bewusst ohne Designsystem-JS: kein Ripple, kein Router,
// damit die Seite mit wenigen KB Skript auskommt. Texte über window.tr aus /js/i18n.js.
// Stile kommen über den eigenen Einstieg public-css (siehe public-entry.css).
// Pfad-Präfix aus der Hülle ('/next' in der Testphase) — bewusst ohne Import (Budget dieser Seite)
const PX = (typeof document !== 'undefined' && document.documentElement.dataset.prefix) ?? '/next';

const tr = (k, v) => (typeof window !== 'undefined' && window.tr ? window.tr(k, v) : k);
const loc = () => (typeof window !== 'undefined' && window.vcLocale) || (typeof document !== 'undefined' && document.documentElement.lang) || 'de';
const getJson = (url) => fetch(url, { credentials: 'same-origin' }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
const num = (n) => Number(n).toLocaleString(loc());

/** Zahl nur übernehmen, wenn sie wirklich da ist — sonst bleibt der serverseitige Wert stehen. */
export function setStat(el, value) {
  if (!el || value == null || value === '' || !Number.isFinite(Number(value)) || Number(value) <= 0) return false;
  el.textContent = num(value);
  return true;
}

/** Wer ist hier? 'user' (angemeldet), 'returning' (Konto im Browser gemerkt), sonst 'new'. */
export function visitorKind(me, remembered) {
  if (me && me.id) return 'user';
  return remembered ? 'returning' : 'new';
}

function adaptCtas(kind, me) {
  const ctas = document.querySelectorAll('[data-pub-cta]');
  if (kind === 'user') {
    for (const a of ctas) { a.href = PX + '/app'; a.textContent = tr('landing_js.cta_to_app'); }
    for (const a of document.querySelectorAll('[data-pub-login]')) a.hidden = true;
    const hello = document.querySelector('[data-pub-hello]');
    if (hello) { hello.textContent = tr('landing_js.logged_in_hint', { name: me.name || tr('landing_js.default_name') }); hello.hidden = false; }
  } else if (kind === 'returning') {
    for (const a of ctas) { a.href = PX + '/login?next=' + PX + '/app'; a.textContent = tr('landing_js.cta_login'); }
  }
}

function init() {
  const $ = (q) => document.querySelector(q);
  // Je Seite nur abfragen, was sie anzeigt.
  if ($('[data-stat]')) getJson('/api/landing-stats').then((d) => {
    if (!d) return;
    for (const k of ['spots', 'countries', 'reviews']) setStat($(`[data-stat="${k}"]`), d[k]);
  });
  if ($('#founder-count, #pricing-count')) getJson('/api/public/founder-status').then((d) => {
    if (!d || d.remaining == null) return;
    for (const id of ['founder-count', 'pricing-count']) { const el = document.getElementById(id); if (el) el.textContent = num(d.remaining); }
  });
  if ($('#featured-free')) getJson('/api/public/featured-offer').then((d) => {
    if (d && typeof d.remaining === 'number') $('#featured-free').textContent = num(d.remaining);
  });
  // Ratgeber: Checkliste drucken
  document.addEventListener('click', (e) => { if (e.target.closest && e.target.closest('[data-print]')) print(); });
  if ($('[data-pub-version]')) getJson('/api/public/version').then((d) => { if (d && d.version) $('[data-pub-version]').textContent = d.version; });
  if (!$('[data-pub-cta]')) return;
  let remembered = false;
  try { remembered = localStorage.getItem('vc-registered') === '1'; } catch {}
  if (remembered) adaptCtas('returning');
  getJson('/api/me').then((me) => {
    const kind = visitorKind(me, remembered);
    if (kind === 'user') { try { localStorage.setItem('vc-registered', '1'); } catch {} }
    adaptCtas(kind, me);
  });
}

// Service Worker nur, wenn die Seite die installierbare App ist (Manifest verlinkt = nach dem Umschalten).
function registerSw() {
  if (!document.querySelector('link[rel="manifest"]') || !('serviceWorker' in navigator)) return;
  addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(() => {}), { once: true });
}

if (typeof document !== 'undefined') { init(); registerSw(); }
